import {
  Button as BaseButton,
  ButtonProps as ChakraButtonProps,
} from '@chakra-ui/react'
import { forwardRef } from 'react'

export type ButtonProps = {
  primary?: boolean
  secondary?: boolean
} & ChakraButtonProps

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      children,
      primary,
      secondary,
      colorScheme: colorSchemeProp,
      variant: variantProp,
      ...restProps
    },
    ref,
  ) => {
    const colorScheme = primary
      ? 'primary'
      : secondary
        ? 'greys'
        : colorSchemeProp
    // Lift primary buttons by default unless `variant` prop is explicitly set.
    const variant =
      primary && variantProp === undefined ? 'lifted' : variantProp
    return (
      <BaseButton
        ref={ref}
        colorScheme={colorScheme}
        variant={variant}
        {...restProps}
      >
        {children}
      </BaseButton>
    )
  },
)

Button.displayName = 'Button'
export default Button
